import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { RigLogFilters, RigLogSlice } from "./rigLogsTypes.ts";

const initialState: RigLogSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "createdTime",
    order: "desc",
  },
};

export const rigLogsSlice = createSlice({
  name: "rigLogs",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<RigLogSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<RigLogSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof RigLogFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<RigLogSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  rigLogsSlice.actions;

export const selectPage = (state: RootState) => state.rigLogs.page;
export const selectRowsPerPage = (state: RootState) =>
  state.rigLogs.rowsPerPage;
export const selectFilter = (state: RootState) => state.rigLogs.filter;
export const selectSort = (state: RootState) => state.rigLogs.sort;

export default rigLogsSlice.reducer;
